import {
  RbTable,
  RbToolbarActionButton,
  RbToolbarActions,
  RbToolbarMultiSelectField,
  RbToolbarSearchField,
  Tooltip,
} from "@scmlatam/web-ui";
import type { Row } from "../types/component";

import ToolbarSearchIcon from "../../../../assets/icons/toolbar-search-icon.svg";
import type { useStepper } from "../hooks/useStepper";
import { EmptyState } from "@scmlatam/web-ui";

const StepEmployee = (props: ReturnType<typeof useStepper>) => {
  const {
    t,
    filter,
    setFilter,
    tags,
    tagSelected,
    setTagSelected,
    searchTag,
    setSearchTag,
    search,
    columns,
    rows,
    range,
    rowSelected,
    setRowSelected,
    loading,
  } = props;

  if (!props.canViewEmployees) {
    return <EmptyState variant="no-permission" context="page" permissions={props.requiredEmployeePermissions.map((permission) => permission.permission)} />;
  }

  return (
    <>
      <RbTable<Row>
        toolbarLeft={<></>}
        toolbarRight={
          <>
            <RbToolbarSearchField
              value={filter}
              onChange={setFilter}
              placeholder="Buscar..."
            />

            <RbToolbarMultiSelectField
              label={t("step3.table.toolbar.tags.label")}
              placeholder={t("step3.table.toolbar.tags.placeholder")}
              value={tagSelected}
              onChange={(value) => {
                setTagSelected(value);
              }}
              options={tags}
              search={{
                value: searchTag,
                onChange: setSearchTag,
                placeholder: t("step3.table.toolbar.tags.seach_placeholder"),
              }}
            />

            <RbToolbarActions>
              <Tooltip content={t("step3.tooltip.search")}>
                <RbToolbarActionButton
                  variant="outlinedIcon"
                  disabled={
                    !(
                      range[0]?.isValid() &&
                      range[1]?.isValid() &&
                      tagSelected.length > 0
                    ) || loading
                  }
                  loading={loading}
                  onClick={() => {
                    search(
                      range[0]?.format("YYYY-MM-DD") || "",
                      range[1]?.format("YYYY-MM-DD") || "",
                      tagSelected.join(","),
                    );
                  }}
                  icon={
                    <img
                      src={ToolbarSearchIcon}
                      alt="toolbar-search-icon"
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                />
              </Tooltip>
            </RbToolbarActions>
          </>
        }
        columns={columns}
        rows={rows}
        loading={false}
        checkboxSelection={true}
        rowSelectionModel={rowSelected}
        setRowSelectionModel={setRowSelected}
      />
    </>
  );
};
export { StepEmployee };
